module.exports = __webpack_public_path__ + "static/media/quote-frame-pc.bb0b8e8c.jpg";